import {
  tenantFeatures_exports
} from "./chunk-VJF6V4RE.js";

// src/services/config.ts
var ServiceConfig = {
  baseAPIUrl: process.env.REACT_APP_API_URL,
  user: {
    users: "/Users",
    uniqueEmail: "/checkUniqueMail?email="
  }
};

// src/services/cookie.ts
var getCookie = (name) => {
  const cookie = document.cookie.split("; ").find((c) => c.startsWith(name));
  if (!!cookie) {
    const value = cookie.split("=")[1];
    return value;
  }
};
var setCookie = (name, value, maxAge) => {
  document.cookie = `${name}=${value}; Path=/;${!!maxAge ? ` Max-Age=${maxAge}` : ""}`;
};
var clearCookie = (name) => setCookie(name, "", -1);

// src/services/crud.ts
var getAuthHeaderFromSessionStorage = (sessionStorageId) => {
  const userValueString = sessionStorage.getItem(sessionStorageId);
  if (!userValueString) {
    return void 0;
  }
  try {
    const userJSON = JSON.parse(userValueString);
    return userJSON.token && userJSON.token.length ? { Authorization: `Bearer ${userJSON.token}` } : void 0;
  } catch {
    if (userValueString.length > 0)
      return { Authorization: `Bearer ${userValueString}` };
  }
};
var setAuthHeaderInSessionStorage = (sessionStorageId, token) => sessionStorage.setItem(sessionStorageId, token);
var removeAuthHeaderFromSessionStorage = (sessionStorageId) => sessionStorage.removeItem(sessionStorageId);
var getAuthHeaderFromCookie = (cookieName) => {
  const token = getCookie(cookieName);
  return !!token ? { Authorization: `Bearer ${token}` } : void 0;
};
var setAuthHeaderInCookie = (cookieName, token, expiresInMinutes = 360) => setCookie(cookieName, token, 60 * expiresInMinutes);
var removeAuthHeaderFromCookie = (cookieName) => clearCookie(cookieName);
var authHeader = void 0;
var getLocalAuthHeader = () => authHeader;
var setLocalAuthHeader = (token) => authHeader = { Authorization: `Bearer ${token}` };
var clearLocalAuthHeader = () => authHeader = void 0;
var adminTenantIdHeader = void 0;
var getAdminTenantIdHeader = () => adminTenantIdHeader;
var setAdminTenantIdHeader = (tenantId) => adminTenantIdHeader = { AdminTenantId: `${tenantId}` };
function createCrud(tokenKey, redirectPath, cookie = false) {
  const storageAllowed = navigator.cookieEnabled;
  const getAdminTenantHeader = () => getAdminTenantIdHeader();
  const setAdminTenantHeader = (tenantId) => setAdminTenantIdHeader(tenantId);
  const getAuthHeader2 = () => storageAllowed ? cookie ? getAuthHeaderFromCookie(tokenKey) : getAuthHeaderFromSessionStorage(tokenKey) : getLocalAuthHeader();
  const setAuthHeader2 = (token, expiresInMinutes) => storageAllowed ? cookie ? setAuthHeaderInCookie(tokenKey, token, expiresInMinutes) : setAuthHeaderInSessionStorage(tokenKey, token) : setLocalAuthHeader(token);
  const clearAuthHeader2 = () => storageAllowed ? cookie ? removeAuthHeaderFromCookie(tokenKey) : removeAuthHeaderFromSessionStorage(tokenKey) : clearLocalAuthHeader();
  function request2(method, redirectOnUnauthorized = true) {
    return async (url, data = {}, options = {}, redirect) => {
      const authHeader2 = getAuthHeader2();
      const adminTenantHeader = getAdminTenantHeader();
      try {
        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            ...authHeader2,
            ...adminTenantHeader
          },
          credentials: "include",
          body: Object.keys(data).length ? JSON.stringify(data) : void 0,
          ...options
        });
        if (redirectOnUnauthorized && response.status === 401) {
          window.location.hash = redirect ? redirect : `${redirectPath}/unknown`;
        }
        return response;
      } catch (error) {
        const resp = {
          ok: false,
          json: () => Promise.resolve(
            "Problem with remote server connection. " + (error instanceof Error ? error.message : error)
          ),
          status: 100
        };
        return resp;
      }
    };
  }
  const get2 = request2("get");
  const getNoRedirect = request2("get", false);
  const patch2 = request2("patch");
  const post2 = request2("post");
  const put2 = request2("put");
  const remove2 = request2("delete");
  const isUnexpectedResponseError2 = (value) => {
    return !!value && value.ok === false && value.json !== void 0;
  };
  return {
    get: get2,
    getNoRedirect,
    patch: patch2,
    post: post2,
    put: put2,
    remove: remove2,
    request: request2,
    isUnexpectedResponseError: isUnexpectedResponseError2,
    getAuthHeader: getAuthHeader2,
    setAuthHeader: setAuthHeader2,
    clearAuthHeader: clearAuthHeader2,
    setAdminTenantHeader
  };
}

// src/services/crudFuctions.ts
var {
  get,
  patch,
  put,
  post,
  remove,
  request,
  isUnexpectedResponseError,
  getAuthHeader,
  setAuthHeader,
  clearAuthHeader
} = createCrud("authToken", "", true);
function isAPIValidationError(obj) {
  return typeof obj.title === "string";
}
function validationErrorsToMap(error) {
  const { errors = {} } = error;
  return new Map(Object.keys(errors).map((k) => [k.toLowerCase(), errors[k]]));
}
function isAPIError(obj) {
  return typeof obj.Message === "string";
}

// src/services/getBlobObjectURL.ts
var getBlobObjectURL = (url, getAuthHeader2) => {
  const authHeader2 = getAuthHeader2();
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...authHeader2
    },
    credentials: "include",
    body: void 0
  }).then((response) => {
    return response.blob();
  }).then((blob) => {
    return URL.createObjectURL(blob);
  }).catch((error) => {
    console.log(error);
    return "";
  });
};

// src/services/toQueryString.ts
var toQueryString = (params) => {
  return new URLSearchParams(params).toString();
};
var objectToQueryString = (params) => {
  const queryString = Object.keys(params).reduce((prev, key) => {
    if (!!params[key]) {
      if (Array.isArray(params[key])) {
        const arr = params[key].map((v) => `${key}=${v}`);
        return [...prev, ...arr];
      }
      return [...prev, `${key}=${params[key]}`];
    }
    return [...prev];
  }, []).join("&");
  return queryString;
};

// src/environment.ts
var base = { env: process.env.REACT_APP_ENV };
function readEnv() {
  switch (base.env) {
    case "dev":
    case "qa":
    case "staging":
    case "sandbox":
    case "testing":
    case "prod":
      return base.env;
    default:
      return "unset";
  }
}
var environment = readEnv();
function isEnv(test) {
  if (Array.isArray(test)) {
    return test.includes(environment);
  }
  return environment === test;
}
var isProduction = isEnv("prod");

// src/theme/GlobalStyles.tsx
import * as React from "react";
import { GlobalStyles } from "@mui/material";
var SCGlobalStyles = /* @__PURE__ */ React.createElement(
  GlobalStyles,
  {
    styles: {
      html: {
        width: "100% !important",
        maxWidth: "100% !important",
        overflowX: "hidden !important",
        margin: 0,
        padding: 0
      },
      body: {
        width: "100% !important",
        maxWidth: "100% !important",
        overflowX: "hidden !important",
        margin: 0,
        padding: 0
      },
      ".Toastify__toast-container": {
        color: "#000"
      },
      ".Toastify__close-button": {
        color: "#000"
      },
      ".Toastify__toast--info": {
        background: "#B6E1FF"
      },
      ".Toastify__toast--success": {
        background: "#E2FDE2"
      },
      ".Toastify__toast--warning": {
        background: "#FFF5CC"
      },
      ".Toastify__toast--error": {
        background: "#F9D0CD"
      },
      ".form-control": {
        width: "50%",
        border: "1px solid #ccc",
        padding: "10px"
      },
      ".form-control-login": {
        width: "33%",
        border: "1px solid #ccc",
        padding: "10px"
      },
      ".control-error": {
        border: "1px solid red"
      },
      "#left-toolbar": {
        display: "block",
        width: "180px",
        transition: "all 0.3s ease-in-out",
        zIndex: 998,
        ".menu ul": {
          fontFamily: "Source Sans Pro Semibold",
          whiteSpace: "nowrap",
          listStyle: "none",
          padding: 0,
          margin: 0,
          "> li": {
            ".menu-option": {
              transition: "font-size 0.3s ease-out",
              color: "white",
              height: "16px",
              display: "inline-block",
              div: {
                height: "16px",
                width: "16px",
                display: "inline-block",
                marginRight: "15px"
              }
            },
            padding: "15px",
            position: "relative",
            backgroundColor: "#242424",
            cursor: "pointer",
            "&.single-option": {
              padding: "0px",
              "> a.active": {
                backgroundColor: "lighten(#242424, 7%)"
              }
            },
            "&:not(.single-option)": {
              "&:hover": {
                "&::before": {
                  position: "absolute",
                  top: "18px",
                  right: "0px",
                  height: "16px",
                  width: "8px",
                  content: "url(/static-assets/icons/flyout-triangle.svg)",
                  zIndex: 1e3
                }
              }
            },
            a: {
              color: "white",
              textDecoration: "none",
              display: "inline-block",
              width: "100%",
              padding: "15px"
            },
            "&:hover": {
              backgroundColor: "lighten(#242424, 7%)",
              "> ul": {
                opacity: 1,
                visibility: "visible"
              }
            },
            "&.active": {
              backgroundColor: "lighten(#242424, 7%)"
            }
          },
          ul: {
            width: "230px",
            zIndex: 1e3,
            opacity: 0,
            position: "absolute",
            visibility: "hidden",
            left: "100%",
            top: "-1px",
            boxShadow: "4px 5px 10px -3px #999B9D",
            backgroundColor: "white",
            li: {
              backgroundColor: "white",
              breakInside: "avoid-column",
              padding: "0px",
              "&:hover": {
                backgroundColor: "white",
                color: "lighten(black, 60%)",
                "&.collapsed-menu-title": {
                  cursor: "default",
                  color: "mix(#242424, #258bca, 50%)"
                }
              },
              a: {
                color: "#33383b",
                "&:hover": {
                  color: "lighten(black, 60%)"
                },
                "&.active": {
                  backgroundColor: "white",
                  "&::before": {
                    position: "absolute",
                    top: "10px",
                    left: "5px",
                    height: "32px",
                    width: "3px",
                    backgroundColor: "#8CC82D",
                    content: '""'
                  },
                  "&:hover": {
                    color: "#33383b"
                  }
                }
              },
              "&.collapsed-menu-title": {
                padding: "15px"
              },
              "&:not(:last-child)::after": {
                position: "absolute",
                bottom: 0,
                left: "5%",
                height: "1px",
                display: "block",
                width: "90%",
                background: "darken(#ECECEE, 10%)",
                content: '""'
              }
            }
          }
        },
        "section.toggle-toolbar": {
          textAlign: "right",
          padding: "15px",
          cursor: "pointer"
        },
        ".collapsed-menu-title": {
          display: "none",
          cursor: "default",
          color: "mix(#242424, #258bca, 50%)"
        },
        ".badge": {
          backgroundColor: "#98c748",
          color: "#242424",
          borderRadius: "50%",
          textAlign: "center",
          lineHeight: "1rem",
          fontSize: "0.75rem"
        },
        "&.collapsed": {
          width: "46px",
          ".menu ul > li .menu-option": {
            fontSize: "0px"
          },
          ".collapsed-menu-title": {
            display: "block",
            "&:hover": {
              color: "mix(#242424, #258bca, 50%)"
            }
          }
        },
        /* Tablet & Smaller */
        "@media only screen and (min-width : 0px)": {
          width: "46px",
          ".menu ul > li .menu-option": {
            color: "transparent",
            fontSize: "0px"
          },
          ".collapsed-menu-title": {
            display: "block",
            color: "mix(#242424, #258bca, 50%)",
            "&:hover": {
              color: "mix(#242424, #258bca, 50%)"
            }
          },
          "section.toggle-toolbar": {
            display: "none"
          }
        },
        /* Desktop */
        "@media only screen and (min-width : 1200px)": {
          width: "180px",
          ".menu ul > li .menu-option": {
            color: "white",
            fontSize: "1rem"
          },
          ".collapsed-menu-title": {
            display: "none"
          },
          "&.collapsed": {
            ".collapsed-menu-title": {
              display: "block"
            }
          },
          "section.toggle-toolbar": {
            display: "block"
          }
        }
      },
      "@media only screen and (min-width : 0px)": {
        ".form-row-head h3": {
          fontSize: "3vh"
        },
        ".content-col h3": {
          fontSize: "3vh"
        },
        ".form-form": {
          width: "100%"
        },
        ".form-wrapper": {
          display: "block"
        },
        "#left-toolbar": {
          display: "block",
          backgroundColor: "#242424"
        },
        ".form-row": {
          display: "block",
          padding: ".5em",
          width: "100%"
        },
        ".form-control": {
          width: "100%"
        },
        ".flex-container": {
          display: "flex",
          alignItems: "stretch",
          backgroundColor: "#f1f1f1",
          height: "100vh"
        }
      },
      "@media only screen and (min-width : 1200px)": {
        ".form-row-head h3": {
          fontSize: "3vh"
        },
        ".content-col h3": {
          fontSize: "3vh"
        },
        ".form-row": {
          display: "block",
          padding: ".5em",
          width: "50%"
        },
        ".form-control": {
          width: "50%"
        },
        ".flex-container": {
          display: "flex",
          alignItems: "stretch",
          backgroundColor: "#f1f1f1",
          height: "100vh"
        }
      },
      ".content-col": {
        flexGrow: 20,
        display: "flex",
        backgroundColor: "rgb(241, 241, 241)",
        justifyContent: "center"
      },
      ".sidebar-col": {
        display: "flex",
        flexGrow: 1,
        backgroundColor: "#002d5c",
        textAlign: "center"
      },
      ".form-column-label": {
        padding: ".5em 1em .5em 0",
        flex: 1,
        display: "flex"
      },
      ".form-column-input": {
        flex: 2,
        textAlign: "left",
        display: "block"
      },
      ".form-logout": {
        display: "block",
        justifyContent: "center",
        backgroundColor: "inherit",
        backgroundImage: "linear-gradient(to right, #258bc9 1%, #002d5c 99%)",
        textAlign: "right",
        height: "6vh"
      },
      ".form-wrapper": {
        display: "block",
        justifyContent: "left",
        width: "100%"
      },
      ".form-row-head": {
        display: "flex",
        justifyContent: "center",
        padding: ".5em",
        width: "100%"
      },
      ".form-form": {
        width: "100%"
      },
      ".form-button-row": {
        justifyContent: "center",
        display: "flex"
      },
      ".menu": {
        backgroundColor: "#242424"
      },
      ".user-form-save": {
        marginLeft: "1%",
        width: "33%"
      },
      ".user-form-cancel": {
        marginLeft: "1%",
        width: "33%"
      },
      ".form-row-login": {
        display: "block",
        padding: ".5em",
        width: "100%",
        textAlign: "center"
      },
      ".form-column-input-login": {
        flex: 2,
        textAlign: "center"
      },
      ".logout-button": {
        width: "18vh"
      },
      ".form-column-label-login": {
        textAlign: "left",
        width: "25%",
        display: "inline-block"
      }
    }
  }
);

// src/theme/muiTheme.ts
import {
  experimental_extendTheme as extendTheme,
  inputBaseClasses,
  outlinedInputClasses
} from "@mui/material";
var toolbarHeight = "78px";
var toolbarHeightCssVar = "--sc-toolbar-height";
var toolbarHeightVar = `var(${toolbarHeightCssVar}, ${toolbarHeight})`;
var viewportHeightCssVar = "--sc-viewport-height";
var viewportHeightVar = `var(${viewportHeightCssVar}, 100dvh)`;
var CALENDAR_COLOR_BASES = {
  // Design's #0ea5e9 fails WCAG AA (2.77:1); oceanBlue[500] passes (5.7:1).
  sales_center: "#1565c0",
  activity_reminder: "#1565c0",
  next_action_date: "#0369a1",
  expected_close_date: "#0f766e",
  pestpac: "#0e283f",
  // tidalColors.slateBlueGray[900] (dark → solid fill)
  google: "#f59e0b",
  // warning
  unknown: "#757575"
  // grey[600]
};
var CALENDAR_STATUS_COLORS = {
  Todo: { text: "#0369a1", background: "#eff6ff", border: "#bfdbfe" },
  InProgress: { text: "#312e81", background: "#eef2ff", border: "#c7d2fe" },
  Deferred: { text: "#92400e", background: "#fffbeb", border: "#fde68a" },
  Complete: { text: "#0f766e", background: "#effaf7", border: "#b6e3d9" }
};
var salesCenterLegacyTheme = extendTheme({
  spacing: 10,
  breakpoints: {
    values: {
      xs: 0,
      sm: 668,
      md: 900,
      lg: 1126,
      xl: 1536
    }
  },
  palette: {
    tidalColors: {
      lobsterRed: {
        50: "#FBECE9",
        100: "#F7DAD5",
        200: "#ECA598",
        300: "#E58270",
        400: "#F1674F",
        500: "#D63B1F",
        600: "#A62E18",
        700: "#892614",
        800: "#621B0E",
        900: "#3C1009"
      },
      slateBlueGray: {
        "50": "#EBEDEF",
        "100": "#D3D7DC",
        "200": "#BAC1C8",
        "300": "#A1ACB4",
        "400": "#8996A1",
        "500": "#70808D",
        "600": "#586A7A",
        "700": "#3F5466",
        "800": "#273E53",
        "900": "#0E283F",
        A700: "#091B2A"
      },
      seafoamTeal: {
        "50": "#e7f5f6",
        "100": "#cfeaed",
        "200": "#b8e0e4",
        "300": "#9fd5db",
        "400": "#6fbfc8",
        "500": "#53b3be",
        "600": "#0f95a4",
        "700": "#0b707b",
        "800": "#074a52",
        "900": "#042529"
      },
      oceanBlue: {
        "50": "#e1ebf7",
        "100": "#d4e3f3",
        "200": "#a1c1e6",
        "300": "#699dd7",
        "400": "#4383cc",
        "500": "#1565c0",
        "600": "#11539d",
        "700": "#0e4686",
        "800": "#061c35",
        "900": "#002d5c",
        A100: "#64acff",
        A200: "#3e98ff",
        A700: "#2b6ab2"
      },
      lightGreen: {
        "50": "#f1f8e9",
        "100": "#dcedc8",
        "200": "#c5e1a5",
        "300": "#aed581",
        "400": "#a6cb72",
        "500": "#8bc34a",
        "600": "#7cb342",
        "700": "#689f38",
        "800": "#558b2f",
        "900": "#33691e",
        A100: "#ccff90",
        A200: "#b2ff59",
        A400: "#76ff03",
        A700: "#64dd17"
      },
      pink: {
        "50": "#fce4ec",
        "100": "#f8bbd0",
        "200": "#f48fb1",
        "300": "#f06292",
        "400": "#ec407a",
        "500": "#e91e63",
        "600": "#d81b60",
        "700": "#c2185b",
        "800": "#ad1457",
        "900": "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162"
      },
      purple: {
        "50": "#f3e5f5",
        "100": "#e1bee7",
        "200": "#ce93d8",
        "300": "#ba68c8",
        "400": "#ab47bc",
        "500": "#9c27b0",
        "600": "#8e24aa",
        "700": "#7b1fa2",
        "800": "#6a1b9a",
        "900": "#4a148c",
        A100: "#ea80fc",
        A200: "#e040fb",
        A400: "#d500f9",
        A700: "#aa00ff"
      },
      sunnyYellow: {
        "50": "#fef8e9",
        "100": "#fef2d4",
        "200": "#fcdf96",
        "300": "#fbd36d",
        "400": "#fac748",
        "500": "#f9ba1b",
        "600": "#cc9816",
        "700": "#ae8212",
        "800": "#89660f",
        "900": "#453408"
      },
      jadeGreen: {
        "50": "#e0f2e9",
        "100": "#c5e1d4",
        "200": "#a5d0b6",
        "300": "#85be9a",
        "400": "#6fbf8c",
        "500": "#53b37a",
        "600": "#3fa86f",
        "700": "#487e5f",
        "800": "#386349",
        "900": "#0d7c4c"
      }
    },
    calendarColors: CALENDAR_COLOR_BASES,
    calendarStatus: CALENDAR_STATUS_COLORS,
    text: {
      primary: "#33383b",
      secondary: "#190734",
      disabled: "#989898"
    },
    primary: {
      main: "#002d5c",
      light: "#003e80",
      dark: "#1565c0",
      contrastText: "#fff"
    },
    secondary: {
      main: "#d5d5d5",
      light: "#ba68c8",
      dark: "#A1C1E6"
    },
    error: {
      main: "#a52727",
      light: "#ef5350",
      dark: "#c62828"
    },
    background: {
      default: "#F9FAFB",
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      default3: "#EAEEF2",
      paper: "#fff"
    },
    common: {
      black: "#000",
      white: "#fff"
    },
    success: {
      main: "#2e7d32",
      light: "#4caf50"
    },
    grey: {
      50: "#fafafa",
      300: "#e0e0e0",
      600: "#757575"
    },
    action: {
      active: "rgba(0, 0, 0, 0.54)"
    }
  },
  typography: {
    fontFamily: "Source Sans Pro, sans-serif",
    button: { textTransform: "none" },
    caption: {
      fontSize: "12px",
      lineHeight: "19.92px",
      letterSpacing: "0.4px"
    },
    subtitle1: {
      fontSize: "16px",
      lineHeight: "28px",
      letterSpacing: "0.15px"
    },
    subtitle2: {
      fontSize: "14px",
      lineHeight: "21.98px",
      letterSpacing: "0.1px",
      fontFamily: "Source Sans Pro SemiBold"
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    subtitle3: {
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.15px",
      fontFamily: "Source Sans Pro SemiBold"
    },
    subtitle4: {
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "20.02px",
      letterSpacing: "0.25px",
      fontFamily: "Source Sans Pro SemiBold"
    },
    body1: { fontSize: "14px" },
    body2: {
      fontSize: "14px",
      lineHeight: "20.02px",
      letterSpacing: "-0.15px"
    },
    h6: {
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      fontFamily: "Source Sans Pro SemiBold"
    },
    h7: {
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "21.6px",
      letterSpacing: "0.15px",
      fontFamily: "Source Sans Pro SemiBold"
    }
  },
  components: {
    MuiAlert: { styleOverrides: { root: { alignItems: "center" } } },
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiRadio: { defaultProps: { color: "primary" } },
    MuiSelect: {
      styleOverrides: {
        select: {
          "&:focus": { backgroundColor: "none" }
        },
        nativeInput: {
          color: "rgba(0, 0, 0, 0.87)"
        }
      }
    },
    MuiSwitch: { defaultProps: { color: "primary" } },
    MuiTabs: { defaultProps: { TabIndicatorProps: { color: "primary" } } },
    MuiInput: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.87)"
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.87)",
          [`&.${inputBaseClasses.disabled}`]: {
            backgroundColor: "#f5f5f5"
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.6)"
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: "#d4d4d4"
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        variant: "outlined"
      },
      styleOverrides: {
        root: {
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.6)"
          }
        }
      }
    },
    MuiLink: { defaultProps: { underline: "hover" } }
  }
});

// src/store/hooks/useAppDispatch.ts
import { useDispatch } from "react-redux";
var useAppDispatch = () => {
  const dispatch = useDispatch();
  return dispatch;
};

// src/store/loadingState/actions.ts
var updateLoadingState = (payload) => ({
  type: "wwm.application.updateLoadingState",
  payload
});

// src/store/loadingState/initialLoadingState.ts
var initialState = {
  loadingState: "hidden"
};

// src/store/utils/createReducer.ts
import { produce } from "immer";
var createReducer = (defaultState, cases, _actionNamespacePrefix = "wwm") => (state = defaultState, action) => produce(state, (draft) => {
  if (action && action.type) {
    const reaction = cases[action.type];
    if (reaction) {
      reaction(draft, action.payload);
    }
  }
});

// src/store/loadingState/reducer.ts
var reducer = createReducer(
  initialState,
  {
    "wwm.application.updateLoadingState": (draft, newLoadingState) => {
      draft.loadingState = newLoadingState;
      return draft;
    }
  }
);

// src/typings/ENTITY_TYPES.ts
var ENTITY_TYPES = /* @__PURE__ */ ((ENTITY_TYPES2) => {
  ENTITY_TYPES2["Lead"] = "LEAD";
  ENTITY_TYPES2["Opportunity"] = "OPPORTUNITY";
  ENTITY_TYPES2["DraftLead"] = "DRAFTLEAD";
  return ENTITY_TYPES2;
})(ENTITY_TYPES || {});

// src/typings/IAddress.ts
var emptyAddress = {
  address: "",
  address2: "",
  city: "",
  state: "",
  postalCode: "",
  latitude: 0,
  longitude: 0
};

// src/typings/ISearchInput.ts
function searchInputToQueryString(input) {
  const { query, skip, take, branchIds } = input;
  const qstring = [];
  if (!!query) {
    if (typeof query === "string")
      qstring.push(`query=${encodeURIComponent(query)}`);
    else
      query.filter((q) => q.trim().length > 0).map((q) => qstring.push(`orQueries=${encodeURIComponent(q.trim())}`));
  }
  if (!!skip) qstring.push(`skip=${skip}`);
  if (!!take) qstring.push(`take=${take}`);
  if (!!branchIds) {
    if (typeof branchIds === "string")
      qstring.push(`branchIds=${encodeURIComponent(branchIds)}`);
    else
      branchIds.map((b) => qstring.push(`branchIds=${encodeURIComponent(b)}`));
  }
  return qstring.join("&");
}
function pageToSearchInput(page, perPage, query, branchIds) {
  return {
    skip: Math.max(page - 1, 0) * perPage,
    take: perPage,
    query,
    branchIds
  };
}

// src/typings/constants.ts
var externalProductPestPacName = "PestPac";
var closedLostOpportunityStageName = "Closed/Lost";
var closedWonOpportunityStageName = "Closed/Won";
var nullAndCustomCloseLostReasonsIds = ["-1", "0"];
var nullCloseLostReasonsId = -1;
var customCloseLostReasonsId = "0";
var TenantLocale = /* @__PURE__ */ ((TenantLocale2) => {
  TenantLocale2["USA"] = "USA";
  TenantLocale2["CANADA"] = "CAN";
  return TenantLocale2;
})(TenantLocale || {});
var TenantLocalDateFormat = /* @__PURE__ */ ((TenantLocalDateFormat2) => {
  TenantLocalDateFormat2["USA_FORMAT"] = "MM/dd/yyyy";
  TenantLocalDateFormat2["CANADA_FORMAT"] = "yyyy/MM/dd";
  return TenantLocalDateFormat2;
})(TenantLocalDateFormat || {});

// src/typings/SoldServiceStatuses.ts
var SOLD_SERVICE_STATUS = /* @__PURE__ */ ((SOLD_SERVICE_STATUS2) => {
  SOLD_SERVICE_STATUS2["NotSent"] = "NotSent";
  SOLD_SERVICE_STATUS2["Submitted"] = "Submitted";
  SOLD_SERVICE_STATUS2["Processing"] = "Processing";
  SOLD_SERVICE_STATUS2["Revise"] = "Revise";
  SOLD_SERVICE_STATUS2["Completed"] = "Completed";
  return SOLD_SERVICE_STATUS2;
})(SOLD_SERVICE_STATUS || {});

// src/typings/Request.ts
var PestPacTimeoutExpirationStatus = 598;
var PestPacTimeoutExpirationErrorMessage = "There was an error processing your request in PestPac. If this problem persists, please contact support.";

// src/typings/EXTERNAL_ENTITY_TYPE.ts
var EXTERNAL_ENTITY_TYPE = /* @__PURE__ */ ((EXTERNAL_ENTITY_TYPE2) => {
  EXTERNAL_ENTITY_TYPE2["ServiceSetups"] = "service setup";
  EXTERNAL_ENTITY_TYPE2["ServiceOrders"] = "service order";
  EXTERNAL_ENTITY_TYPE2["Programs"] = "program";
  return EXTERNAL_ENTITY_TYPE2;
})(EXTERNAL_ENTITY_TYPE || {});

// src/utils/address.ts
function getFormattedAddress(lineOne, lineTwo, city, state, postalCode) {
  const stateAndPostalCode = [state, postalCode].filter(Boolean).join(" ");
  return [lineOne, lineTwo, city, stateAndPostalCode].filter(Boolean).join(", ");
}
function getServiceLocationTitle(location) {
  const stateAndPostalCode = [location.stateAbbreviation, location.postalCode].filter(Boolean).join(" ");
  const address = [
    location.street1,
    location.street2,
    location.city,
    stateAndPostalCode
  ].filter(Boolean).join(", ");
  if (getDefaultAddress(address)) return address;
  const name = `${location.firstName} ${location.lastName}`;
  if (name.trim().length > 0) return name;
  else return location.company;
}
function getDefaultAddress(address) {
  return address && address.replace(",", "").trim().length > 0;
}
function getServiceLocationWithContactName(location) {
  const stateAndPostalCode = [location.stateAbbreviation, location.postalCode].filter(Boolean).join(" ");
  const address = [
    location.street1,
    location.street2,
    location.city,
    stateAndPostalCode
  ].filter(Boolean).join(", ");
  if (getDefaultAddress(address)) {
    if (location.firstName || location.lastName) {
      return `${[location.firstName, location.lastName].filter(Boolean).join(" ")} - ${address}`;
    }
    if (location.company) {
      return `${location.company} - ${address}`;
    }
    return address;
  }
  if (location.firstName || location.lastName) {
    return [location.firstName, location.lastName].filter(Boolean).join(" ");
  }
  return `${location.company}`;
}

// src/utils/ApiKey.ts
var saveApiKey = (token) => {
  sessionStorage.setItem("ApiKey", token);
};

// src/utils/asyncDispatch.ts
function wrapAsync(dispatch) {
  return (action) => {
    if (action instanceof Promise) {
      return action.then(dispatch);
    }
    return dispatch(action);
  };
}

// src/utils/currency.ts
var currencyString = (value) => {
  const num = typeof value === "string" ? currencyNumber(value) : value;
  return num.toLocaleString(void 0, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
    // style: 'currency',
    // currency: 'USD',
  });
};
var currencyNumber = (value) => {
  return Number(clean(value));
};
var clean = (value) => {
  const cleaned = value.replace(/[^-?\d\.]/g, "");
  if (cleaned.includes(".")) {
    const [dollars, float] = cleaned.split(".");
    const cents = float.slice(0, 2).padEnd(2, "0");
    return `${dollars}.${cents}`;
  }
  return cleaned;
};

// src/utils/date.ts
import { format, addMinutes } from "date-fns";
var getCulture = () => {
  return "en-US";
};
var localDate = (date) => date && [
  date.getFullYear(),
  ("0" + (date.getMonth() + 1)).slice(-2),
  ("0" + date.getDate()).slice(-2)
].join("-");
var dateWithOffset = (date, days) => {
  const dateInMs = date.getTime() + 864e5 * days;
  return new Date(dateInMs);
};
var shortDate = (dateInput, culture) => {
  culture = culture || getCulture();
  if (!dateInput) return "";
  try {
    dateInput = new Date(dateInput);
    const options = {
      year: "2-digit",
      month: "numeric",
      day: "numeric"
    };
    const formattedTime = new Intl.DateTimeFormat(culture, options).format(
      dateInput
    );
    return formattedTime;
  } catch {
    return "Invalid date";
  }
};
var timeFormat = (dateInput, culture) => {
  culture = culture || getCulture();
  if (!dateInput) return "";
  try {
    dateInput = new Date(dateInput);
    const options = {
      hour: "numeric",
      minute: "numeric"
    };
    const formattedTime = new Intl.DateTimeFormat(culture, options).format(
      dateInput
    );
    return formattedTime;
  } catch {
    return "Invalid date";
  }
};
var creditCardExpirationDate = (dateInput, culture) => {
  culture = culture || getCulture();
  if (!dateInput) return "";
  try {
    dateInput = new Date(dateInput);
    const options = {
      year: "numeric",
      month: "2-digit"
    };
    const formattedTime = new Intl.DateTimeFormat(culture, options).format(
      dateInput
    );
    return formattedTime;
  } catch {
    return "Invalid date";
  }
};
var isValidDate = (d) => d instanceof Date && !isNaN(d.getTime());
var isValidMuiDate = (d) => {
  if (d === null) return false;
  else {
    const localDate2 = new Date(d);
    return !isNaN(localDate2.getTime()) && localDate2.getDate() < 32 && localDate2.getDate() > 0 && localDate2.getFullYear() >= 1900 && localDate2.getFullYear() <= 2099 && localDate2.getMonth() >= 0 && localDate2.getMonth() <= 11;
  }
};
var shortDateScheduling = (dateInput, culture) => {
  culture = culture || getCulture();
  if (!dateInput) return "";
  try {
    dateInput = new Date(dateInput);
    const options = {
      weekday: "long",
      month: "short",
      day: "2-digit"
    };
    const formattedTime = new Intl.DateTimeFormat(culture, options).format(
      dateInput
    );
    return formattedTime;
  } catch {
    return "Invalid date";
  }
};
function formatODataDate(date) {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss'Z'");
}
function dateTimeForXGrid(date) {
  return format(date, "MM/dd/yyyy hh:mm a");
}
function getNowDateTimeUTC(date) {
  return formatODataDate(addMinutes(date, date.getTimezoneOffset()));
}

// src/utils/emotion.ts
var ignoreSSRWarning = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */";

// src/utils/filterByEntity.ts
function filterByEntity(items, entityId, entityType) {
  return items.filter(
    (i) => i.entityId === entityId && i.entityType === entityType
  );
}

// src/utils/getTouchedObject.ts
var getTouchedObject = (errors) => {
  const touched = {};
  Object.keys(errors).map((key) => {
    if (Array.isArray(errors[key])) {
      errors[key].map((val, index) => {
        if (index == 0) touched[key] = [];
        touched[key].push(getTouchedObject(val));
      });
    } else {
      touched[key] = true;
    }
  });
  return touched;
};

// src/utils/objectKeys.ts
function objectKeys(obj) {
  return Object.keys(obj);
}

// src/utils/percentage.ts
function clean2(value) {
  return value.replace(/[^\d\.]/g, "");
}
function formatPercentage(value) {
  return `${clean2(value)}%`;
}
function stringPercentToNumber(value) {
  return Number(clean2(value)) / 100;
}

// src/utils/removeEmptyProps.ts
function removeEmptyProps(obj, excludeProps) {
  if (!!excludeProps) {
    if (typeof excludeProps === "string") {
      delete obj[excludeProps];
    } else {
      excludeProps.map((k) => delete obj[k]);
    }
  }
  Object.keys(obj).map((k) => {
    if (obj[k] === null || obj[k] === void 0 || obj[k] === "") {
      delete obj[k];
    }
  });
  return obj;
}

// src/utils/setDeepNestedProperty.ts
function setDeepNestedProperty(obj, path, value, setrecursively = false) {
  path.reduce((a, b, level) => {
    if (setrecursively && typeof a[b] === "undefined" && level !== path.length - 1) {
      a[b] = {};
      return a[b];
    }
    if (level === path.length - 1) {
      a[b] = value;
      return value;
    }
    return a[b];
  }, obj);
}

// src/utils/sortArrayByArray.ts
function sortArrayByArray(items, sortOrder, fieldSelect) {
  return items.slice().sort((a, b) => {
    const aField = fieldSelect(a);
    const bField = fieldSelect(b);
    return sortOrder.indexOf(aField) - sortOrder.indexOf(bField);
  });
}

// src/utils/strings.ts
var splitCamelCase = (camelCaseString) => {
  return camelCaseString.split(/(?=[A-Z])/).join(" ");
};
var escapeODataString = (value) => {
  if (!value) return "null";
  const odataEscaped = value.replace(/'/g, "''");
  return encodeURIComponent(odataEscaped);
};

// src/utils/trimStrings.ts
var trimString = (value) => {
  const trimmedName = value.trim();
  const withoutExtraSpaces = trimmedName.replace(/\s+/g, " ");
  return withoutExtraSpaces;
};

// src/utils/validation.ts
var isValidEmail = (email) => {
  const regexp = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return regexp.test(email);
};
var isValidPhone = (phone) => {
  return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(phone);
};
var isValidPhoneExtension = (phone) => {
  return /^[0-9]{1,6}$/.test(phone);
};
var updatePhoneValueSearch = (phoneNumber) => {
  phoneNumber = phoneNumber.replace(/-|[{()}\s]/g, "");
  if (phoneNumber.length == 10) {
    phoneNumber = phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3);
    phoneNumber = phoneNumber.slice(0, 7) + "-" + phoneNumber.slice(7);
  }
  return phoneNumber;
};
var updatePhoneValueForm = (phoneNumber, isDeleteMode) => {
  const formatted = phoneNumber.replace(/-/g, "");
  if (formatted.length == 3) {
    return formatted + (isDeleteMode ? "" : "-");
  }
  if (formatted.length > 3 && formatted.length < 6) {
    return formatted.slice(0, 3) + "-" + formatted.slice(3);
  }
  if (formatted.length == 6) {
    return formatted.slice(0, 3) + "-" + formatted.slice(3) + (isDeleteMode ? "" : "-");
  }
  if (formatted.length > 6) {
    return formatted.slice(0, 3) + "-" + formatted.slice(3, 6) + "-" + formatted.slice(6);
  }
  return phoneNumber;
};
var updateEmailValueSearch = (email) => {
  return email ? email.split(/[,;]/)[0] : email;
};
var updatePhoneNumber = (phoneNumber) => {
  return phoneNumber ? phoneNumber.replace(/[{()}]/g, "") : phoneNumber;
};

// src/utils/hooks/usePopoverActions.ts
import { useRef, useCallback } from "react";
function usePopoverActions() {
  const popoverActionsRef = useRef(null);
  const updatePosition = useCallback(
    () => void popoverActionsRef.current?.updatePosition(),
    []
  );
  return {
    popoverActionsRef,
    updatePosition
  };
}

// src/utils/hooks/useBoolean.ts
import { useCallback as useCallback2, useState } from "react";
function useBoolean(initialState2 = false) {
  const [state, setState] = useState(initialState2);
  const onToggle = useCallback2(() => setState((current) => !current), []);
  const onSetTrue = useCallback2(() => setState(true), []);
  const onSetFalse = useCallback2(() => setState(true), []);
  return { state, onSetTrue, onSetFalse, onToggle };
}

// src/utils/hooks/useCheckUniqueEmail.ts
import { useState as useState2, useEffect } from "react";
var baseUrl = `${ServiceConfig.baseAPIUrl}/Users`;
var useCheckUniqueEmail = () => {
  const [emailAddress, setEmailAddress] = useState2();
  const [userId, setUserId] = useState2();
  const [isUnique, setIsUnique] = useState2();
  const [withSSOcheck, setWithSSOcheck] = useState2(false);
  const [status, setStatus] = useState2(
    "idle"
  );
  useEffect(() => {
    let mounted = true;
    const execute = async () => {
      if (emailAddress) {
        setStatus("pending");
        try {
          const input = {
            email: emailAddress,
            userId
          };
          const response = await post(
            `${baseUrl}/checkUniqueMail/${withSSOcheck}`,
            input
          );
          if (response.ok) {
            const isUniqueEmail = await response.json();
            setIsUnique(isUniqueEmail);
          }
        } catch (error) {
          setIsUnique(void 0);
          if (mounted) {
            setStatus("fail");
          }
        } finally {
          setStatus("idle");
        }
      } else {
        setIsUnique(void 0);
      }
    };
    execute();
    return () => {
      mounted = false;
    };
  }, [emailAddress, userId, withSSOcheck]);
  return { isUnique, status, setEmailAddress, setUserId, setWithSSOcheck };
};
export {
  CALENDAR_COLOR_BASES,
  CALENDAR_STATUS_COLORS,
  ENTITY_TYPES,
  EXTERNAL_ENTITY_TYPE,
  PestPacTimeoutExpirationErrorMessage,
  PestPacTimeoutExpirationStatus,
  SCGlobalStyles,
  SOLD_SERVICE_STATUS,
  ServiceConfig,
  tenantFeatures_exports as TenantFeatures,
  TenantLocalDateFormat,
  TenantLocale,
  clearAuthHeader,
  clearCookie,
  closedLostOpportunityStageName,
  closedWonOpportunityStageName,
  createCrud,
  createReducer,
  creditCardExpirationDate,
  currencyNumber,
  currencyString,
  customCloseLostReasonsId,
  dateTimeForXGrid,
  dateWithOffset,
  emptyAddress,
  environment,
  escapeODataString,
  externalProductPestPacName,
  filterByEntity,
  formatODataDate,
  formatPercentage,
  get,
  getAuthHeader,
  getBlobObjectURL,
  getCookie,
  getCulture,
  getDefaultAddress,
  getFormattedAddress,
  getNowDateTimeUTC,
  getServiceLocationTitle,
  getServiceLocationWithContactName,
  getTouchedObject,
  ignoreSSRWarning,
  initialState,
  isAPIError,
  isAPIValidationError,
  isEnv,
  isProduction,
  isUnexpectedResponseError,
  isValidDate,
  isValidEmail,
  isValidMuiDate,
  isValidPhone,
  isValidPhoneExtension,
  localDate,
  nullAndCustomCloseLostReasonsIds,
  nullCloseLostReasonsId,
  objectKeys,
  objectToQueryString,
  pageToSearchInput,
  patch,
  post,
  put,
  reducer,
  remove,
  removeEmptyProps,
  request,
  salesCenterLegacyTheme,
  saveApiKey,
  searchInputToQueryString,
  setAuthHeader,
  setCookie,
  setDeepNestedProperty,
  shortDate,
  shortDateScheduling,
  sortArrayByArray,
  splitCamelCase,
  stringPercentToNumber,
  timeFormat,
  toQueryString,
  toolbarHeight,
  toolbarHeightCssVar,
  toolbarHeightVar,
  trimString,
  updateEmailValueSearch,
  updateLoadingState,
  updatePhoneNumber,
  updatePhoneValueForm,
  updatePhoneValueSearch,
  useAppDispatch,
  useBoolean,
  useCheckUniqueEmail,
  usePopoverActions,
  validationErrorsToMap,
  viewportHeightCssVar,
  viewportHeightVar,
  wrapAsync
};
//# sourceMappingURL=index.js.map